import React, { Component } from "react";
import Paper from "material-ui/Paper";
import Divider from "material-ui/Divider";
import DoneIcon from "react-material-icons/icons/action/done";
import PendingIcon from "react-material-icons/icons/action/alarm";
import FailedIcon from "react-material-icons/icons/alert/error";
import InProgressIcon from "react-material-icons/icons/image/timelapse";

import config from "../../config.json";

import "./style.css";

export default class Result extends Component {
  constructor(props) {
    super(props);
    this.state = { check: true };
  }

  statusToIcon(status) {
    if (status === "COMPLETED") {
      return <DoneIcon />;
    }
    if (status === "PROCESSING" || status === "IN QUEUE") {
      return <PendingIcon />;
    }
    if (status === "RUNNING") {
      return <InProgressIcon />;
    }
    if (status === "FAILED") {
      return <FailedIcon />;
    }
    return "";
  }

  formatDate(date) {
    const month = date.getMonth() + 1;
    const hour = date.getHours() < 10 ? "0" + date.getHours() : date.getHours();
    const minutes =
      date.getMinutes() < 10 ? "0" + date.getMinutes() : date.getMinutes();
    const day = date.getDate() < 10 ? "0" + date.getDate() : date.getDate();
    const seconds =
      date.getSeconds() < 10 ? "0" + date.getSeconds() : date.getSeconds();
    return `${date.getFullYear()}-${month}-${day} at ${hour}:${minutes}:${seconds}`;
  }

  loadData() {
    const { jobId } = this.props.match.params;
    fetch(config.jobEndpoint + "/" + jobId)
      .then(response => {
        return response.json();
      })
      .then(json => {
        if (
          json.status !== "COMPLETED" &&
          json.status !== "FAILED" &&
          this.state.check
        ) {
          setTimeout(() => this.loadData(), 15000);
        }
        this.setState({ data: json });
      })
      .catch(function(ex) {
        setTimeout(() => {
          document.location = "/404";
        }, 1000);
        console.log("parsing failed", ex);
      });
  }

  componentDidMount() {
    this.loadData();
    // const jobId = '1222'
    // const jobData = {
    //     id: jobId,
    //     status: 'done', // icons - done (finished), alarm (pending), timelapse (in progress)
    //     summary: 'Job completed successfully.\n12 buried water molecules found.',
    //     creationDate: 1506835600,

    //     initFile: 'structure.pdb',
    //     waterFile: 'grid_w.pdb',
    //     summaryFile: `summary_${jobId}.txt`,
    //     logFile: `${jobId}.log`,
    //     allFiles: `gsolvate_${jobId}.zip`,
    //     urlExpire: 1506945600
    // };

    // this.setState({data: jobData});
  }

  componentWillUnmount() {
    this.setState({ check: false });
  }

  getSummary = () => {
    const { data: { status } } = this.state;
    switch (status) {
      case "RUNNING":
        return `This page will be refreshed every 15 seconds`;
      case "SUBMITTED":
        return `This page will be refreshed every 15 seconds`;
      default:
        return ``;
    }
  };

  render() {
    const { data } = this.state;
    const expireDate =
      data && data.urlExpire ? new Date(data.urlExpire * 1000) : false;
    const creationDate =
      data && data.creationDate ? new Date(data.creationDate * 1000) : false;

    const addNewLine = lines =>
      lines.split("\n").map(item => <p className="summary">{item}</p>);

    return (
      <div>
        <Paper className={"paper-container"}>
          {data ? (
            <div>
              <h2>
                Job {data.id} submitted on {this.formatDate(creationDate)}.
              </h2>
              <p style={{ display: "flex", alignItems: "center" }}>
                <span>Job status: </span> <span>&nbsp;{data.status}&nbsp;</span>{" "}
                {this.statusToIcon(data.status)}
              </p>
              {data.uuid && <p>UUID: {data.uuid}</p>}
              <p>{this.getSummary()}</p>
              <Paper className={"result-form"}>
                <h4>Results:</h4>
                {addNewLine(data.summary ? data.summary : "")}
                <br />
                <Divider />
                <p>
                  <span>Initial structure:</span>
                  <a
                    target="_blank"
                    href={`${config.fileEndpoint}/${data.id}/init`}
                  >
                    {data.initFile}
                  </a>
                </p>
                <Divider />
                <p>
                  <span>All added water molecules:</span>
                  <a
                    target="_blank"
                    href={`${config.fileEndpoint}/${data.id}/waterAdded`}
                  >
                    {data.waterAdded}
                  </a>
                </p>
                <Divider />
                <p>
                  <span>Buried water molecules:</span>
                  <a
                    target="_blank"
                    href={`${config.fileEndpoint}/${data.id}/waterBuried`}
                  >
                    {data.waterBuried}
                  </a>
                </p>
                <Divider />
                <p>
                  <span>Log file:</span>
                  <a
                    target="_blank"
                    href={`${config.fileEndpoint}/${data.id}/logFile`}
                  >
                    {data.logFile}
                  </a>
                </p>
                <Divider />
                <p>
                  <span>All files:</span>
                  <a
                    target="_blank"
                    href={`${config.fileEndpoint}/${data.id}/output`}
                  >
                    {data.output}
                  </a>
                </p>
              </Paper>
              <br />
              <br />
              {expireDate ? (
                <Paper style={{ padding: "16px" }}>
                  Note: this page will expire on {this.formatDate(expireDate)}.
                </Paper>
              ) : (
                ""
              )}
            </div>
          ) : (
            ""
          )}
        </Paper>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/ResultComponet/index.js